import { Navigate, Outlet, useLocation } from 'react-router-v7';
import { routePath } from 'rooting/routes';
import { userStore } from 'stores/userStore/userStore';

export default function PublicRoute() {
	const location = useLocation();
	const previousLocation = location.state?.from as string;

	if (userStore.userContext.isLogged) {
		if (![routePath.login, routePath.home].includes(previousLocation)) {
			return <Outlet />;
		}
		return <Navigate to={previousLocation} />;
	}
	return <Outlet />;
}
